import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";


import axios from "axios";
import { Provider } from "react-redux";
import { store } from './Redux/store';



axios.defaults.baseURL = "https://bewakoofdatabank.herokuapp.com";


// axios.defaults.baseURL = "http://localhost:8080";


axios.defaults.headers.post["Content-Type"] = "application/json";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>

      <Provider store={store}>
        

          <App />
        
      </Provider>
  
    </BrowserRouter>
    
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
